import TabsPresentation from 'components/Tabs/TabsPresentation'

export default {
  Presentation: TabsPresentation,
}
